<template>
  <div>
    <div class="py-5">
      <p
        class="text-black font-medium lg:text-3xl md:text-3xl sm-fsize20 lg:pb-6 md:pb-5 pb-2 w-full"
      >
        Course content
      </p>

      <div class="" v-for="(item, index) in course" :key="index">
        <p
          class="font-normal fsize18px sm-fsize14 cust-fontstyle"
          v-html="item.content.toString()"
        ></p>
        <i class="fa fa-check mr-4 text-warning"></i>
        <!-- Learn to use Python professionally, learning both Python 2 and Python
      3! -->

        <!-- <p class="font-normal text-md pt-2">
          <i class="fa fa-check mr-4 text-warning"></i>
          Create games with Python, like Tic Tac Toe and Blackjack!
        </p>

        <p class="font-normal text-md pt-2">
          <i class="fa fa-check mr-4 text-warning"></i>
          Learn advanced Python features, like the collections module and how to
          work with timestamps!
        </p>
        <p class="font-normal text-md pt-2">
          <i class="fa fa-check mr-4 text-warning"></i>
          Learn to use Object Oriented Programming with classes!
        </p>

        <p class="font-normal text-md pt-2">
          <i class="fa fa-check mr-4 text-warning"></i>
          Understand complex topics, like decorators.
        </p>

        <p class="font-normal text-md pt-2">
          <i class="fa fa-check mr-4 text-warning"></i>
          Build a complete understanding of Python from the ground up!
        </p>

        <p class="font-normal text-md pt-2">
          <i class="fa fa-check mr-4 text-warning"></i>
          Understand how to use both the Jupyter Notebook and create .py files
        </p>

        <p class="font-normal text-md pt-2">
          <i class="fa fa-check mr-4 text-warning"></i>
          Get an understanding of how to create GUIs in the Jupyter Notebook
          system!
        </p> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import FeatherIcon from "../../../../../components/FeatherIcon.vue";
export default {
  components: { FeatherIcon },
  data() {
    return {
      course: [],
    };
  },
  methods: {
    a() {
      this.course.push(this.selectedCourseHome);

      // // console.log(this.selectedCourseHome);
      // console.log(this.course.content);
    },
  },
  mounted() {
    this.a();
  },
  computed: {
    ...mapState("eLearning", ["selectedCourseHome"]),
  },
};
</script>

<style>
ul.bullet {
  list-style-type: square;
}
.cust-fontstyle > * {
  font-weight: 400;
}
ol {
  list-style-type: decimal;
}
ul {
  list-style-type: disc;
}
</style>
